module.exports = __webpack_public_path__ + "static/media/Gtown.3f316fd3.jpg";